import React from 'react';
import PropTypes from 'prop-types';

export default function SectionHead({ tag, title, subtitle }) {
  return (
    <div className="section-head">
      <span className="section-tag">{tag}</span>
      <h2 className="section-title">{title}</h2>
      {subtitle && <p className="section-subtitle">{subtitle}</p>}
    </div>
  );
}

SectionHead.propTypes = {
  tag: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};
